import React from "react";
import "./Loader.css";
import icon from "../../Asset/startRecordingIcon.svg";
import { ReactSVG } from "react-svg";

const DemoLoader = () => {
  return (
    <div className="relative flex items-center justify-center p-2.5">
      <svg className="demoLoader" viewBox="25 25 50 50">
        <circle className="loaderCricle" r="20" cy="50" cx="50"></circle>
      </svg>
      <div className="absolute w-[49px] h-[49px]">
        <ReactSVG
          src={icon}
          beforeInjection={(svg) => {
            svg.setAttribute("class", "w-full h-full");
          }}
        />
      </div>
    </div>
  );
};

export default DemoLoader;
